import * as React from 'react';
import cn from 'classnames';

import { DropdownContentItem } from 'shared/newEntities/components/DropdownContent';

import DropdownContent from '../DropdownContent';

import './DropdownContentList.modules.scss';

type Props = {
  items: DropdownContentItem[];
  className?: string;
  itemClassName?: string;
  defaultId?: string | null;
  titleLimited?: boolean;
  withModal?: boolean;
  onChangeSelectedId?: (id: string | null) => void;
  withMarginCompensation?: boolean;
};

const DropdownContentList: React.FC<Props> = ({
  items,
  className,
  itemClassName,
  defaultId,
  titleLimited,
  withModal,
  onChangeSelectedId,
  withMarginCompensation
}) => {
  const [selectedId, setSelectedId] = React.useState<string | null>(
    defaultId || null
  );

  const handleClick = React.useCallback(
    (id: string | null) => {
      setSelectedId(id);
      onChangeSelectedId?.(id);
    },
    [onChangeSelectedId]
  );

  React.useEffect(() => {
    if (defaultId === undefined) {
      return;
    }

    setSelectedId(defaultId);
  }, [defaultId]);

  return (
    <div styleName="list" className={className}>
      {items.map((item) => {
        const selected = selectedId === item.id;

        return (
          <DropdownContent
            {...item}
            key={item.id}
            opened={selected}
            onClick={handleClick}
            titleLimited={titleLimited}
            styleName={cn('item', selected && !withModal && 'item_selected')}
            className={itemClassName}
            withModal={withModal}
            withMarginCompensation={withMarginCompensation}
          />
        );
      })}
    </div>
  );
};

export default React.memo(DropdownContentList);
